// extracted by mini-css-extract-plugin
export default {"container":"Sk-z","bubbleNav":"Tk-z","graphic":"Uk-z","contact":"Vk-z"};